
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 51.01 36.93"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M4.16 21.62H15.8a1 1 0 001-1v-6.75a1 1 0 00-1-1H8.52a1 1 0 00-.86.46L3.3 20a1 1 0 00.86 1.62zm4.92-6.72h5.69v4.67H6.05z"}}),_c('path',{attrs:{"d":"M50 0H18.88a1 1 0 00-1 1v8.77h-11a1 1 0 00-.86.47l-5.83 9a1 1 0 00-.16.55v11.53a1 1 0 001 1H5a5.6 5.6 0 0011 0h18a5.6 5.6 0 0011 0h5a1 1 0 001-1V1a1 1 0 00-1-1zM19.9 2.05H49v20.81H19.9zm-9.44 32.83A3.56 3.56 0 1114 31.32a3.57 3.57 0 01-3.54 3.56zm7.39-4.58H16a5.61 5.61 0 00-11 0H2.05V20.09l5.35-8.27h10.45zm21.68 4.58a3.56 3.56 0 113.56-3.56 3.57 3.57 0 01-3.56 3.56zM49 30.29h-4a5.6 5.6 0 00-11 0H19.9v-5.38H49z"}})])])
          )
        }
      }
    